<p-confirmDialog
  header="Confirmation"
  key="supplier-invoice-dialog"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>
<p-dialog
  [header]="progressBarTitle"
  modal="true"
  [(visible)]="showProgressBar"
  appendTo="body"
  (onHide)="hideProgressBar()"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>
<h2 class="sub-header-bar">Supplier Invoices</h2>

<form (ngSubmit)="search()" style="width: 100%">
  <div class="ui-g filterPanel">
    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.from.value"
          name="invoiceDateFrom"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>From</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <p-calendar
          [(ngModel)]="filterVal.filters.to.value"
          name="invoiceDateTo"
          dateFormat="dd/mm/yy"
        ></p-calendar>
        <label>To</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2" style="margin-top: 10px">
      <span class="filterItem">
        <p-checkbox
          [(ngModel)]="filterVal.filters.awaitingVerification.value"
          name="awaitingVerification"
          binary="true"
          label="Awaiting Verification"
        ></p-checkbox>
      </span>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2" style="width: auto">
      <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
      <button
        pButton
        type="button"
        label="Clear"
        class="ui-button btn-to-right ui-button-tertiary"
        (click)="clearFilter(dt)"
      ></button>
    </div>
  </div>
</form>

<p-table
  #dt
  [value]="page.items"
  [lazy]="true"
  [rows]="10"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  resizableColumns="true"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  [hidden]="!isLoaded"
  [rowsPerPageOptions]="[5, 10, 20]"
  [pageLinks]="3"
  [(selection)]="selectedBatch"
  selectionMode="single"
  (onRowSelect)="onBatchSelect($event)"
  [first]="filterVal.first"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  exportFilename="Supplier-Invoice-Batches"
  styleClass="no-print"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="runOn">Batch Date</th>
      <th pSortableColumn="invoicesCount">Number of Invoices</th>
      <th pSortableColumn="transactionLinesCount">Transaction Lines</th>
      <th pSortableColumn="totalAmount">Total Amount</th>
      <th pSortableColumn="approvedBy">Confirmed By</th>
      <th pSortableColumn="approvedAt">Confirmed At</th>
      <th pSortableColumn="xeroInvoiceNumber">Xero Invoice</th>
      <th>IsTestMode</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item">
      <td>{{ item.runOn | datex : 'DD MMM YYYY' }}</td>
      <td>{{ item.invoicesCount }}</td>
      <td>{{ item.transactionLinesCount }}</td>
      <td>{{ item.totalAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
      <td>
        <div *ngIf="item.approvedBy == null" style="text-align: center">
          <p-checkbox
            (click)="confirmBatch(item.id); $event.preventDefault()"
            label="Confirm"
            binary="true"
          ></p-checkbox>
        </div>
        {{ item.approvedBy }}
      </td>
      <td>{{ item.approvedAt | datex : 'ddd DD MMM HH:mm' }}</td>
      <td>{{ item.xeroInvoiceNumber }}</td>
      <td><a href="#" (click)="removeBatch(item.id); $event.preventDefault()">Remove</a></td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLE DEPRECATED
<p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true"
             resizableColumns="true" [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
             [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [(selection)]="selectedBatch"
             selectionMode="single" (onRowSelect)="onBatchSelect($event)" [first]="filterVal.first"
             [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder" exportFilename="Supplier-Invoice-Batches" styleClass="no-print">


    <p-column field="runOn" header="Batch Date" [sortable]="tru" [style]="{'text-align' : 'center'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
        </ng-template>
    </p-column>
    <p-column field="invoicesCount" header="Number of Invoices" [sortable]="tru" [style]="{'text-align' : 'center'}">
    </p-column>
    <p-column field="transactionLinesCount" header="Transaction Lines" [sortable]="tru" [style]="{'text-align' : 'center'}">
    </p-column>
    <p-column field="totalAmount" header="Total Amount" [sortable]="tru" [style]="{'text-align' : 'center'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | currency:'GBP':'symbol':'1.2-2' }}
        </ng-template>
    </p-column>
    <p-column field="approvedBy" header="Confirmed by" [sortable]="tru">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <div *ngIf="item[col.field] == null" style="text-align: center">
                <p-checkbox (click)="confirmBatch(item.id); $event.preventDefault();"
                            label="Confirm" binary="true"></p-checkbox>
            </div>
            {{ item[col.field] }}
        </ng-template>
    </p-column>
    <p-column field="approvedAt" header="Confirmed At" [sortable]="tru" [style]="{'text-align' : 'center'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'ddd DD MMM HH:mm' }}
        </ng-template>
    </p-column>
    <p-column field="xeroInvoiceNumber" header="Xero Invoice" [sortable]="tru"></p-column>
    <p-column *ngIf="isTestMode" [sortable]="false" [style]="{'text-align' : 'center'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <a href="#" (click)="removeBatch(item.id);$event.preventDefault();">Remove</a>
        </ng-template>
    </p-column>
</p-dataTable>
--->

<div class="ui-grid-row" *ngIf="selectedBatch && !hideInvoicesTillBatchesUpdate">
  <div class="ui-g-12">
    <!---->
    <suppliers-invoices-grid
      #invoicesGrid
      [processingStatus]="1"
      [batchId]="selectedBatch.id"
      [manageMode]="2"
      (onGridAction)="onSupplierInvoicesGridAction($event)"
    >
    </suppliers-invoices-grid>
  </div>
</div>

<div class="ui-grid-row no-print" style="margin-top: 30px">
  <div class="ui-g-12 card mt-3">
    <button
      type="button"
      pButton
      label="Process Invoices {{ supplierInvoiceProcess.isDryRun == true ? '' : '- Live Run' }}"
      class="ui-button btn-to-right"
      (click)="processInvoices()"
      (paste)="processInvoices()"
      [ngClass]="{
        '': supplierInvoiceProcess.isDryRun,
        'ui-button-danger': !supplierInvoiceProcess.isDryRun
      }"
    ></button>
    <p-calendar
      name="plannedRunDay"
      [(ngModel)]="plannedRunDay"
      dateFormat="yy-mm-dd"
      [showIcon]="true"
      [style]="{ float: 'right', 'margin-right': '20px', 'padding-top': '5px' }"
    ></p-calendar>
    <div style="float: right; padding-top: 7px; margin-right: 10px">Planned run day</div>
    <input
      autocomplete="off"
      name="sipPassPhrase"
      pInputText
      placeholder="{{ supplierInvoiceProcess.enableWetModeMsg }}"
      class="invoice-process-wet-mode"
      (keyup)="verifyRunMode($event, supplierProcessInvoiceTypes.SupplierInvoice)"
    />
  </div>

  <div class="ui-g-12 card mt-3">
    <button
      type="button"
      pButton
      label="Process Batches {{ supplierBatchProcess.isDryRun == true ? '' : '- Live Run' }}"
      class="ui-button btn-to-right"
      [ngClass]="{
        '': supplierBatchProcess.isDryRun,
        'ui-button-danger': !supplierBatchProcess.isDryRun
      }"
      (click)="processBatches()"
      (paste)="processBatches()"
    ></button>
    <p-calendar
      name="batchesPlannedRunDay"
      [(ngModel)]="batchesPlannedRunDay"
      dateFormat="yy-mm-dd"
      [showIcon]="true"
      [style]="{ float: 'right', 'margin-right': '20px', 'padding-top': '5px' }"
    ></p-calendar>
    <div style="float: right; padding-top: 7px; margin-right: 10px">Planned run day</div>
    <input
      autocomplete="off"
      name="sipPassPhrase"
      pInputText
      placeholder="{{ supplierBatchProcess.enableWetModeMsg }}"
      class="invoice-process-wet-mode"
      (keyup)="verifyRunMode($event, supplierProcessInvoiceTypes.SupplierBatch)"
    />
  </div>

  <div class="ui-g-12 card mt-3">
    <button
      type="button"
      pButton
      label="Process Payments {{ supplierPaymentProcess.isDryRun == true ? '' : '- Live Run' }}"
      class="ui-button btn-to-right"
      [ngClass]="{
        '': supplierPaymentProcess.isDryRun,
        'ui-button-danger': !supplierPaymentProcess.isDryRun
      }"
      (click)="processPayments()"
      (paste)="processPayments()"
    ></button>
    <p-calendar
      name="paymentPlannedRunDay"
      [(ngModel)]="paymentPlannedRunDay"
      dateFormat="yy-mm-dd"
      [showIcon]="true"
      [style]="{ float: 'right', 'margin-right': '20px', 'padding-top': '5px' }"
    ></p-calendar>
    <div style="float: right; padding-top: 7px; margin-right: 10px">Planned run day</div>
    <input
      autocomplete="off"
      name="sipPassPhrase"
      pInputText
      placeholder="{{ supplierPaymentProcess.enableWetModeMsg }}"
      class="invoice-process-wet-mode"
      (keyup)="verifyRunMode($event, supplierProcessInvoiceTypes.SupplierPayment)"
    />
  </div>

  <div class="ui-g-12 card mt-3">
    <button
      type="button"
      pButton
      label="Process Xero Batches {{
        supplierXeroBatchProcess.isDryRun == true ? '' : '- Live Run'
      }}"
      class="ui-button btn-to-right"
      [ngClass]="{
        '': supplierXeroBatchProcess.isDryRun,
        'ui-button-danger': !supplierXeroBatchProcess.isDryRun
      }"
      (click)="processXeroBatches()"
      (paste)="processXeroBatches()"
    ></button>
    <p-calendar
      name="xeroBatchesPlannedRunDay"
      [(ngModel)]="xeroBatchesPlannedRunDay"
      dateFormat="yy-mm-dd"
      [showIcon]="true"
      [style]="{ float: 'right', 'margin-right': '20px', 'padding-top': '5px' }"
    ></p-calendar>
    <div style="float: right; padding-top: 7px; margin-right: 10px">Planned run day</div>
    <input
      autocomplete="off"
      name="sipPassPhrase"
      pInputText
      placeholder="{{ supplierXeroBatchProcess.enableWetModeMsg }}"
      class="invoice-process-wet-mode"
      (keyup)="verifyRunMode($event, supplierProcessInvoiceTypes.SupplierXeroBatches)"
    />
  </div>

  <div *ngIf="billResults">
    <div class="ui-g-12">
      <h1>Supplier Invoices Billing Result</h1>

      <p-table
        #dt_invoice_billing
        [columns]="invoiceBillingColumns"
        [value]="billResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="billResults.length"
        sortField="transactionsLinked"
        sortOrder="-1"
        exportFilename="Supplier-Invoice-Billing-Results"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="supplierName">Supplier</th>
            <th pSortableColumn="isSelfBilled">Self Billed</th>
            <th pSortableColumn="selfBillingValidity">Self Billing Validity</th>
            <th pSortableColumn="statusString">Status</th>
            <th pSortableColumn="statusDetails">Status Details</th>
            <th pSortableColumn="amount">Total Amount</th>
            <th pSortableColumn="transactionsLinked">Transactions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>
              {{ item.supplierName }}
            </td>
            <td>{{ item.isSelfBilled ? 'Yes' : 'No' }}</td>
            <td>{{ item.selfBillingValidity | datex : 'DD MMM YYYY' }}</td>
            <td>{{ item.statusString }}</td>
            <td>
              <p title="{{ item.statusDetails }}">{{ item.statusDetails }}</p>
            </td>
            <td>{{ item.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            <td>{{ item.transactionsLinked }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED --
      <p-dataTabl #dt_invoice_billing [value]="billResults" [rows]="1000" [responsive]="true" [paginator]="false"
                   rowHover="true"
                   resizableColumns="true" [totalRecords]="billResults.length"
                   sortField="transactionsLinked" sortOrder="-1" exportFilename="Supplier-Invoice-Billing-Results">

        <p-column field="supplierName" header="Supplier" [sortable]="tru"></p-column>
        <p-column field="isSelfBilled" header="Self Billed" [sortable]="tru" styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{item[col.field] ? 'Yes' : 'No'}}
          </ng-template>
        </p-column>
        <p-column field="selfBillingValidity" header="Self Billing Validity" [sortable]="true"
                  styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
          </ng-template>
        </p-column>
        <p-column field="statusString" header="Status" [sortable]="tru"></p-column>
        <p-column field="statusDetails" header="Status details" [sortable]="tru">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <p title="{{item[col.field]}}">{{item[col.field]}}</p>
          </ng-template>
        </p-column>
        <p-column field="amount" header="Total Amount" [sortable]="tru" styleClass="align-center">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{item[col.field] | currency:'GBP':'symbol':'1.2-2'}}
          </ng-template>
        </p-column>
        <p-column field="transactionsLinked" header="Transactions" [sortable]="tru"
                  styleClass="align-center"></p-column>
      </p-dataTable>

      -->

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          pButton
          icon="ui-icon-file-download"
          iconPos="left"
          label="Download"
          (click)="dt_invoice_billing.exportCSV()"
          style="float: right"
        ></button>
      </div>
    </div>
  </div>

  <div *ngIf="emailResults">
    <div class="ui-g-12">
      <h1>Supplier Invoices Emailing Result</h1>

      <p-table
        #dt_invoice_email
        [value]="emailResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="emailResults.length"
        exportFilename="Supplier-Invoice-Emailing-Result"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="invoiceNumber">Invoice</th>
            <th pSortableColumn="statusString">Status</th>
            <th pSortableColumn="statusDetails">Status Details</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.invoiceNumber }}</td>
            <td>{{ item.statusString }}</td>
            <td>{{ item.statusDetails }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLE DEPRECATED --
      <p-dataTabl #dt_invoice_email [value]="emailResults" [rows]="1000" [responsive]="true" [paginator]="false"
                   rowHover="true"
                   resizableColumns="true" [totalRecords]="emailResults.length"
                   exportFilename="Supplier-Invoice-Emailing-Result">
        <p-column field="invoiceNumber" header="Invoice" [sortable]="tru"></p-column>
        <p-column field="statusString" header="Status" [sortable]="tru"></p-column>
        <p-column field="statusDetails" header="Status details" [sortable]="tru"></p-column>
      </p-dataTable>
      --->
      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          pButton
          icon="ui-icon-file-download"
          iconPos="left"
          label="Download"
          (click)="dt_invoice_email.exportCSV()"
          style="float: right"
        ></button>
      </div>
    </div>
  </div>

  <div *ngIf="generateBatchResults">
    <div class="ui-g-12">
      <h1>Batches Generating Result</h1>

      <p-table
        #dt_batches_result
        [value]="generateBatchResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="generateBatchResults.length"
        exportFilename="Supplier-Invoice-Batches-Result"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="runOn">Batch Date</th>
            <th pSortableColumn="invoiceCount">Number of Invoices</th>
            <th pSortableColumn="isIndividualOrg">Is Individual Org</th>
            <th pSortableColumn="month">Month</th>
            <th pSortableColumn="hasVatNumber">Org has VAT</th>
            <th pSortableColumn="vatRate">VAT Rate</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.runOn | datex : 'DD MMM YYYY' }}</td>
            <td>{{ item.invoicesCount }}</td>
            <td>{{ item.params.isIndividualOrg }}</td>
            <td>{{ item.params.month }}</td>
            <td>{{ item.params.hasVatNumber }}</td>
            <td>{{ item.params.vatRate }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLES DEPRECATED --
      <p-dataTabl #dt_batches_result [value]="generateBatchResults" [rows]="1000" [responsive]="true"
                   [paginator]="false" rowHover="true"
                   resizableColumns="true" [totalRecords]="generateBatchResults.length"
                   exportFilename="Supplier-Invoice-Batches-Result">

        <p-column field="runOn" header="Batch Date">
          <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | datex:'DD MMM YYYY' }}
          </ng-template>
        </p-column>
        <p-column field="invoicesCount" header="Number of invoices" [sortable]="tru"></p-column>
        <p-column field="params.isIndividualOrg" header="Is Individual Org" [sortable]="tru"></p-column>
        <p-column field="params.month" header="Month" [sortable]="tru"></p-column>
        <p-column field="params.hasVatNumber" header="Org has VAT number" [sortable]="tru"></p-column>
        <p-column field="params.vatRate" header="VAT Rate" [sortable]="tru"></p-column>
      </p-dataTable>
      --->
      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          pButton
          icon="ui-icon-file-download"
          iconPos="left"
          label="Download"
          (click)="dt_batches_result.exportCSV()"
          style="float: right"
        ></button>
      </div>
    </div>
  </div>

  <div *ngIf="payInvoicesResults">
    <div class="ui-g-12">
      <h1>Batches Payment Result</h1>

      <p-table
        #dt_payemnt
        [value]="payInvoicesResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="payInvoicesResults.length"
        exportFilename="Supplier-Batches-Payment-Result"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="batchId">Batch ID</th>
            <th pSortableColumn="category">Category</th>
            <th pSortableColumn="invoiceNumber">Invoice Number</th>
            <th pSortableColumn="paymentStatus">Payment Status</th>
            <th pSortableColumn="statusString">Processing Status</th>
            <th pSortableColumn="statusDetails">Status Details</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.batchId }}</td>
            <td>{{ item.category }}</td>
            <td>{{ item.invoiceNumber }}</td>
            <td>{{ item.paymentStatus }}</td>
            <td>
              <p title="{{ item.statusString }}">{{ item.statusString }}</p>
            </td>
            <td>
              <p title="{{ item.statusDetails }}">{{ item.statusDetails }}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- DATATABLES DEPRECATED --
      <p-dataTabl #dt_payemnt [value]="payInvoicesResults" [rows]="1000" [responsive]="true" [paginator]="false"
                   rowHover="true"
                   resizableColumns="true" [totalRecords]="payInvoicesResults.length"
                   exportFilename="Supplier-Batches-Payment-Result">
        <p-column field="batchId" header="Batch ID" [sortable]="tru"></p-column>
        <p-column field="category" header="Category" [sortable]="tru"></p-column>
        <p-column field="invoiceNumber" header="Invoice Number" [sortable]="tru"></p-column>
        <p-column field="paymentStatus" header="Payment Status" [sortable]="tru"></p-column>
        <p-column field="statusString" header="Processing Status" [sortable]="tru">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <p title="{{item[col.field]}}">{{item[col.field]}}</p>
          </ng-template>
        </p-column>
        <p-column field="statusDetails" header="Status Details" [sortable]="tru">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <p title="{{item[col.field]}}">{{item[col.field]}}</p>
          </ng-template>
        </p-column>
      </p-dataTable>
      --->
      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          pButton
          icon="ui-icon-file-download"
          iconPos="left"
          label="Download"
          (click)="dt_payemnt.exportCSV()"
          style="float: right"
        ></button>
      </div>
    </div>
  </div>

  <div *ngIf="xeroResults">
    <div class="ui-g-12">
      <h1>Xero Result</h1>

      <p-table
        #dt_xero
        [value]="xeroResults"
        [rows]="1000"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        resizableColumns="true"
        [totalRecords]="xeroResults.length"
        exportFilename="Supplier-Batches-Xero-Result"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Batch ID</th>
            <th>Statuses</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              {{ item.batchId }}
            </td>
            <td>
              <p-table
                [value]="item.statuses"
                [paginator]="false"
                rowHover="true"
                resizableColumns="true"
                [totalRecords]="item.statuses.length"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="statusString">Status</th>
                    <th pSortableColumn="details">Details</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-subitem>
                  <tr>
                    <td>{{ subitem.statusString }}</td>
                    <td>{{ subitem.details }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED ---
      <p-dataTabl #dt_xero [value]="xeroResults" [rows]="1000" [responsive]="true" [paginator]="false" rowHover="true"
                   resizableColumns="true" [totalRecords]="xeroResults.length"
                   exportFilename="Supplier-Batches-Xero-Result">

        <p-column field="batchId" header="Batch ID" [style]="{'width' : '10%'}" [sortable]="tru"></p-column>
        <p-column header="Statuses">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <p-dataTabl [value]="item.statuses" [paginator]="false" rowHover="true"
                         resizableColumns="true" [totalRecords]="item.statuses.length">
              <p-column field="statusString" header="status">
                <ng-template let-col let-item="rowData" pTemplate="body">
                  <p title="{{item[col.field]}}">{{item[col.field]}}</p>
                </ng-template>
              </p-column>
              <p-column field="details" header="details">
                <ng-template let-col let-item="rowData" pTemplate="body">
                  <p title="{{item[col.field]}}">{{item[col.field]}}</p>
                </ng-template>
              </p-column>
            </p-dataTable>
          </ng-template>
        </p-column>
      </p-dataTable>
      -->
      <!-- <div class="footerPanel ui-grid-row">
          <button type="button" pButton icon="ui-icon-file-download" iconPos="left" label="Download" (click)="dt_xero.exportCSV()" style="float:right"></button>
      </div> -->
    </div>
  </div>
</div>
